/**
 * Staff Schedule Page - Olympic Fit Wellness
 * Allows staff to create and manage sessions
 */
import StaffSessionManager from '../../components/calendar/StaffSessionManager';

export default function StaffSchedulePage() {
  return (
    <div className="p-6">
      <StaffSessionManager />
    </div>
  );
}
